import { Box, Card, CardContent, CardHeader, Container, Grid, Typography } from "@mui/material";
import centro from "../../assets/img/centro.png"
import author from "../../assets/img/author.png"
import unidad from "../../assets/img/unidad.png"
import { themePalette } from "../../config/theme.config";
import { Link } from "react-router-dom";

export const ModuloPage: React.FC<{}> = () => {
    return (
        <Container maxWidth="lg" style={{ padding: '20px', textAlign: 'center' }}>
            <Box>
                <Grid container justifyContent="center" alignItems="center" >
                    <Grid item xs={12} sm={10} md={10} container spacing={2} justifyContent="center" alignItems="center">
                        <Grid item xs={10} sm={6} md={6} >
                            <h1>Admin</h1>    

                        </Grid>
                    </Grid>
                </Grid> 

                <Grid
                    container
                    spacing={8}
                    justifyContent="center"
                    alignItems="center"
                >
                    <Grid item xs={12} sm={6} md={6} display="flex" justifyContent="center">
                        <Link to={"/admin/unidades"} style={{ textDecoration: 'none' }}>
                            <Card sx={{ width: 300, height: 200, display: 'flex', flexDirection: 'column' }}>
                                <CardHeader sx={{ backgroundColor: themePalette.COLOR_SIDEBAR_ICON, color: "white", height: 60 }} title="Unidades" />
                                <CardContent sx={{ flex: 1, display: "flex", alignItems: "center", justifyContent: "center" }}>
                                    <img src={unidad} alt="Unidad" style={{ maxWidth: "100%", height: "auto", maxHeight: "100px" }} />
                                </CardContent>
                            </Card>
                        </Link>
                    </Grid>
                    <Grid item xs={12} sm={6} md={6} display="flex" justifyContent="center">
                        <Link to={"/admin/centros"} style={{ textDecoration: 'none' }}>
                            <Card sx={{ width: 300, height: 200, display: 'flex', flexDirection: 'column' }}>
                                <CardHeader sx={{ backgroundColor: themePalette.COLOR_SIDEBAR_ICON, color: "white", height: 60 }} title="Centros" />
                                <CardContent sx={{ flex: 1, display: "flex", alignItems: "center", justifyContent: "center" }}>
                                    <img src={centro} alt="Centro" style={{ maxWidth: "100%", height: "auto", maxHeight: "100px" }} />
                                </CardContent>
                            </Card>
                        </Link>
                    </Grid>
                    <Grid item xs={12} sm={6} md={6} display="flex" justifyContent="center">
                        <Link to={"/admin/investigadores"} style={{ textDecoration: 'none' }}>
                            <Card sx={{ width: 300, height: 200, display: 'flex', flexDirection: 'column' }}>
                                <CardHeader sx={{ backgroundColor: themePalette.COLOR_SIDEBAR_ICON, color: "white", height: 60 }} title="Investigadores" />
                                <CardContent sx={{ flex: 1, display: "flex", alignItems: "center", justifyContent: "center" }}>
                                    <img src={author} alt="Investigador" style={{ maxWidth: "100%", height: "auto", maxHeight: "100px" }} />
                                </CardContent>
                            </Card>
                        </Link>
                    </Grid>
                </Grid>



            
            </Box> 
        </Container>
    )
}